<template>
  <div
    dir="rtl"
    class="flex items-center justify-between border-2 p-4 text-white rounded-md md:w-10/12 w-full cursor-pointer relative z-50"
    :class="isSelected == price?.metadata?.name ? 'border-basic justify-between' : 'border-gray-700'"
 
   @click="$emit('click')"
    style="cursor: pointer;"
  >
    <div class="flex flex-col gap-2" dir="rtl">
      <div class="md:text-[1.4vw] text-md">
        {{ price?.metadata?.title }}
      </div>
    </div>
    <div class="flex flex-col justify-start gap-y-2" dir="ltr">
      <div v-show="isSelected == price?.metadata?.name" class="w-6 h-6 text-center ml-6">
        <plan-checked />
      </div>
      <div class="flex flex-col justify-center items-center">
        <strong class="md:text-[1.4vw] text-md">{{
          price?.metadata?.price / 100
        }}</strong>
        <small class="text-gray-600">{{ "درهم" }}/{{ price.metadata.title }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import PlanChecked from "@/components/svg/PlanChecked.vue";
export default {
  props: ["isSelected", "price"],
  data() {
    return {
    };
  },
  components: {
    PlanChecked,
  },
  created() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
